import { render, staticRenderFns } from "./MyBookings.vue?vue&type=template&id=3061fc57&scoped=true"
import script from "./MyBookings.vue?vue&type=script&lang=ts"
export * from "./MyBookings.vue?vue&type=script&lang=ts"
import style0 from "./MyBookings.vue?vue&type=style&index=0&id=3061fc57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3061fc57",
  null
  
)

export default component.exports